import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authApi = axios.create({
    baseURL: API,
});

// Attach token from localStorage on each request
authApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("carvaelis_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auto-logout on 401
authApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("carvaelis_admin_token");
            if (window.location.pathname.startsWith("/admin") &&
                window.location.pathname !== "/admin/login") {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);

export function setToken(token) {
    localStorage.setItem("carvaelis_admin_token", token);
}

export function getToken() {
    return localStorage.getItem("carvaelis_admin_token");
}

export function clearToken() {
    localStorage.removeItem("carvaelis_admin_token");
}

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Erreur inconnue";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(d);
}
